import { node, fragment, createPremiumIcon } from "~/util/dom";
import { _ } from "~/i18n";
import { createEditContainer } from "~/profile/settings/userspeed/popup/utils";
import { ITypeMaxSpeedItem, CHANGED_CLASS } from "~/profile/settings/userspeed/popup";
import { openPropositionDialog } from "~/util/premium";
import { IUserMaxSpeedData } from "~/state/user/interfaces";

function userMaxSpeedValidation(editItem: ITypeMaxSpeedItem, validationCallback?: (valid?: boolean) => void) {
	let error = false;

	const actualValue = parseFloat(editItem.input.value);
	const changed = !!actualValue;

	editItem.container.classList[changed ? "add" : "remove"](CHANGED_CLASS);

	if (changed) {
		editItem.container.prepend(editItem.reset);
	} else {
		editItem.reset.remove();
	}

	if (!editItem.input.checkValidity() || (editItem.toggle.checked && editItem.input.value === "")) {
		error = true;
	}

	validationCallback && validationCallback(error);
}

export function createMaxSpeedSection(settingsUserMaxSpeedValue: IUserMaxSpeedData, callbackOnNoPremium: () => void, premiumUser, validationCallback: (valid?: boolean) => void = () => {}): {
	container: DocumentFragment;
	item: ITypeMaxSpeedItem;
} {
	const frag = fragment();
	const title = node("div", {});
	const toggle = node("mapy-toggle");
	const maxSpeedTitle = node("h5", {}, _("profile.settings.userspeed.maxSpeed.title"));
	const description = node("p", {}, _("profile.settings.userspeed.maxSpeed.description"));
	const row = node("div", { className: "settings-user-max-speed__content" });
	const column = node("div", { className: "settings-user-max-speed__container-column" });
	const editMessage = node("p", { className: "settings-user-max-speed__paragraph-valid" }, _("profile.settings.userspeed.editMessage"));
	const edit = {
		...createEditContainer(
			settingsUserMaxSpeedValue?.car?.maxSpeed ? settingsUserMaxSpeedValue.car.maxSpeed.toString() : "",
			"",
			"km/h",
			() => {
				userMaxSpeedValidation(edit, validationCallback);
			},
		),
		toggle,
	} as ITypeMaxSpeedItem;

	//edit.input.step = "1";

	edit.input.addEventListener("input", () => {
		userMaxSpeedValidation(edit, validationCallback);
	});

	if (premiumUser && settingsUserMaxSpeedValue?.car?.maxSpeedEnabled) {
		toggle.checked = true;
	}

	toggle.addEventListener("change", () => {
		if (premiumUser) {
			userMaxSpeedValidation(edit, validationCallback);
			Mapy.getComponent("logger").log("car_max_speed_limit", {
				limited: toggle.checked ? "true" : "false",

			});
		} else {
			toggle.checked = false;
			callbackOnNoPremium();
			Mapy.getComponent("logger").log("setCustomSpeeds_premiumPurchase_show");
			openPropositionDialog("setCustomSpeeds");
		}
	});

	title.append(maxSpeedTitle, toggle);

	if (!premiumUser) {
		maxSpeedTitle.after(createPremiumIcon());
	}

	column.append(edit.container, editMessage);

	row.append(description);

	if (premiumUser) {
		row.append(column);
	}

	frag.append(title, row);

	userMaxSpeedValidation(edit, validationCallback);

	return {
		container: frag,
		item: edit,
	};
}

export function getUserMaxSpeedData(item: ITypeMaxSpeedItem) {
	const maxSpeed: IUserMaxSpeedData = {};

	if (item.toggle.checked || item.input.value) {
		maxSpeed.car = {
			...parseFloat(item.input.value) ? { maxSpeed: parseFloat(item.input.value) } : {},
			maxSpeedEnabled: item.toggle.checked,
		};
	}

	return maxSpeed;
}

export function setUserMaxSpeedValue(settingsUserMaxSpeedValue: IUserMaxSpeedData, item: ITypeMaxSpeedItem) {
	item.input.value = settingsUserMaxSpeedValue?.car?.maxSpeed?.toString() || "";
	item.toggle.checked = settingsUserMaxSpeedValue?.car?.maxSpeedEnabled;

	userMaxSpeedValidation(item);
}

export function destroyUserMaxSpeed(item: ITypeMaxSpeedItem) {
	item.tooltip.destroy();
}
